// extracted by mini-css-extract-plugin
export default {"loader":"SplashScreen_loader__0FRwg","rotation":"SplashScreen_rotation__bqpMg"};